// ✅ GOOD: one wrapper per feature
import React from "react";
import "./ImageFeature.css";

export default function ImageFeature({
  href,
  imageSrc,
  imageAlt,
  title,
  description,
}) {
  return (
    <div className=" if-container">
      <a href={href} className="if-image-link">
        <img src={imageSrc} alt={imageAlt} className=" if-image" />
      </a>
      <div className="if-text-row-full">
        <div className="if-text-container">
          <h2 className="if-title">{title}</h2>
          <p className="if-desc">{description}</p>
        </div>
      </div>
    </div>
  );
}
